export const SHOW_LOADER = 'SHOW_LOADER'
export const SHOW_ALERT = 'SHOW_ALERT'
export const CONFIGURE_ALERT = 'CONFIGURE_ALERT'
export const CONFIGURE_SNACKBAR = 'CONFIGURE_SNACKBAR'
export const SET_FILTERS = 'SET_FILTERS';